
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { addVariousTags, deleteVariousTags, getVariousTagsList, modifyVariousTags } from '@/api/allTags';

@Component({
  name: 'SettingTemplateAddedProgress',
  components: {

  }
})
export default class extends Vue {
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private tableData = []
  private addedProgressVisible = false
  private listLoading = false;
  private formData:any = {
    id: '',
    name: ''
  }
  private rulesData:any = {
    name: [
      { required: true, message: '请输入任务描述标签', trigger: 'blur' },
      { pattern: /^((?!").)*$/, message: '请忽填写英文状态下的双引号', trigger: 'blur' }
    ]
  }

  created() {
    this.pagination.currentPage = 1;
    this.getVariousTagsList();
  }

  private getVariousTagsList() {
    let VariousTagsParam: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      type: 2
    };
    getVariousTagsList(VariousTagsParam).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
        this.pagination.total = parseInt(res.data.count);
      } else {
        this.tableData = [];
      }
    }).catch((err: any) => {
      let msg = err.msg;
      this.pagination.total = 0;
      this.pagination.currentPage = 1;
    });
  }

  private editHandle(val:any) {
    this.addedProgressVisible = true;
    this.formData = {
      id: val.id,
      name: val.name
    };
  }
  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getVariousTagsList();
  }
  private handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getVariousTagsList();
  }
  private AddProgressHandle() {
    this.addedProgressVisible = true;
    this.formData = {
      id: '',
      name: ''
    };
  }

  private SaveHandle() {
    if (!this.formData.name) {
      this.showErrorMsg('请输入补充进度');
      return;
    }
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      name: this.formData.name,
      type: 2
    };
    if (!this.formData.id) {
      addVariousTags(params)
        .then((res:any) => {
          this.addedProgressVisible = false;
          this.pagination.currentPage = 1;
          this.getVariousTagsList();
          this.showSuccessMsg(res.msg);
        })
        .catch((err) => {
          let msg = err.msg;
          this.showErrorMsg(msg);
        });
    } else {
      params.tags_id = this.formData.id;
      modifyVariousTags(params)
        .then((res:any) => {
          this.addedProgressVisible = false;
          this.pagination.currentPage = 1;
          this.getVariousTagsList();
          this.showSuccessMsg(res.msg);
        })
        .catch((err) => {
          let msg = err.msg;
          this.showErrorMsg(msg);
        });
    }
  }

  private deleteDataHandle(val:any) {
    this.$confirm('确定删除这条数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          tags_id: val.id,
          type: 2
        };
        deleteVariousTags(params)
          .then((res:any) => {
            this.pagination.currentPage = 1;
            this.getVariousTagsList();
            this.showSuccessMsg(res.msg);
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
